var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['vue-icon', `vue-icon-${_vm.type}`, _vm.classname],style:(_vm.style),attrs:{"aria-label":_vm.type,"viewBox":_vm.icon.viewBox,"width":_vm.size.width,"height":_vm.size.height,"role":"img"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('use',{attrs:{"xlink:href":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }